import {CompanyOrgs} from 'shared/models/company';

export function getOrg(orgs: CompanyOrgs[], id: string) {
  return (orgs || []).find((org) => org.id === id);
}
